class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)

    this.els?.item?.elements.forEach(tempEl => {
      if (tempEl !== itemEl) {
        tempEl.setAttribute('aria-expanded', 'false')
      }
    })

    const contentEl = itemEl.querySelector(this.els?.content?.selector)
    const currentState = itemEl.getAttribute('aria-expanded') === 'true'

    itemEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    itemEl.setAttribute('aria-expanded', !currentState)
  }
}
document.addEventListener('content:replaced', () => {
	new AccordionGroup()
})

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
